import { Big } from 'big.js';

Big.DP = 5; // Big.js decimal places
Big.RM = Big.roundHalfUp; // Big.js rounding mode
